import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('avalanche', {
  cherry: 'snow_boot',
  lemon: 'ice_axe',
  orange: 'climb_rope',
  bell: 'alarm_bell',
  star: 'snowball_wild',
  seven: 'summit_peak',
  gem: 'ice_gem',
  scatter: 'snowflake_scatter',
  money: 'buried_chest',
});

/** Avalanche — GENERATED by scaffoldSlot from
 *  content/slots/avalanche.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const AVALANCHE_THEME: Theme = {
  id: 'avalanche',
  name: 'Avalanche',
  palette: {
    accent: 0x6fa8dc,
    secondary: 0xb3cde8,
    warm: 0xf2d27a,
    frameFill: 0x1b2733,
    bgGradientTop: 0x2e4156,
    bgGradientBottom: 0x0e1620,
    dimOverlay: 0x070b10,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Snow Boot', glyph: '🥾', tint: 0x9c4a3a, weight: 5, textureAlias: 'avalanche:cherry',
        winVideoAlias: 'avalanche:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Ice Axe', glyph: '⛏️', tint: 0x8a96a3, weight: 5, textureAlias: 'avalanche:lemon',
        winVideoAlias: 'avalanche:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Climbing Rope', glyph: '🧗', tint: 0xd98a3a, weight: 4, textureAlias: 'avalanche:orange',
        winVideoAlias: 'avalanche:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Alarm Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'avalanche:bell',
        winVideoAlias: 'avalanche:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Avalanche', glyph: '🌨️', tint: 0xeaf2fb, weight: 2, textureAlias: 'avalanche:star',
        winVideoAlias: 'avalanche:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Summit', glyph: '🏔️', tint: 0x9ec4e8, weight: 2, textureAlias: 'avalanche:seven',
        winVideoAlias: 'avalanche:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Ice Gem', glyph: '💎', tint: 0x6fa8dc, weight: 2.5, textureAlias: 'avalanche:gem',
        winVideoAlias: 'avalanche:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Snowflake', glyph: '❄️', tint: 0xd8ecff, weight: 0.5, textureAlias: 'avalanche:scatter',
        winVideoAlias: 'avalanche:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Buried Hoard', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'avalanche:money',
        winVideoAlias: 'avalanche:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x1b2733, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x6fa8dc, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x1b2733, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xb3cde8, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x6fa8dc, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x1b2733, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x6fa8dc, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xf2d27a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'avalanche:bg', path: 'environment/avalanche.png' },
      columnBackground: { alias: 'avalanche:column_bg', path: 'reel/avalanche_column_bg.png' },
      border: { alias: 'avalanche:border', path: 'brand/border_frost.png' },
    },
  },
};
